/**
 * CRM Multi-Compagnia · Dashboard - Heatmap calendar mese × ramo.
 * Visualizza l'intensità delle scadenze polizze per (mese, ramo).
 */
import { RAMI_LABEL } from "@/components/crm-multi/shared";

const MESI_IT = ["Gen", "Feb", "Mar", "Apr", "Mag", "Giu", "Lug", "Ago", "Set", "Ott", "Nov", "Dic"];

function fmtMese(mm) {
  const [y, m] = mm.split("-");
  return `${MESI_IT[parseInt(m, 10) - 1]} '${y.slice(2)}`;
}

function getColor(count, max) {
  if (count === 0) return "bg-zinc-50";
  const t = count / max;
  if (t > 0.75) return "bg-emerald-700 text-white";
  if (t > 0.5) return "bg-emerald-500 text-white";
  if (t > 0.25) return "bg-emerald-300";
  return "bg-emerald-100";
}

export default function Heatmap({ data, onCellClick }) {
  if (!data || !data.cells || data.cells.length === 0) {
    return <p className="text-xs text-zinc-400 text-center py-8">Nessuna scadenza rilevata</p>;
  }
  const { cells, mesi, rami } = data;
  const max = Math.max(1, ...cells.map(c => c.count));
  const cellMap = {};
  cells.forEach(c => { cellMap[`${c.mese}|${c.ramo}`] = c; });

  return (
    <div className="overflow-x-auto" data-testid="cm-heatmap">
      <table className="w-full text-xs border-separate" style={{ borderSpacing: "2px" }}>
        <thead>
          <tr>
            <th className="text-left px-2 text-zinc-500 font-medium">Ramo / Mese</th>
            {mesi.map(m => (
              <th key={m} className="text-center px-1.5 py-1 text-[10px] text-zinc-500 font-medium whitespace-nowrap">
                {fmtMese(m)}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rami.map(r => (
            <tr key={r}>
              <td className="px-2 py-1 text-[11px] font-medium text-zinc-700 whitespace-nowrap">
                {RAMI_LABEL[r] || r}
              </td>
              {mesi.map(m => {
                const c = cellMap[`${m}|${r}`] || { count: 0, importo: 0 };
                const cls = getColor(c.count, max);
                return (
                  <td key={m + r} className="text-center">
                    <button
                      onClick={() => onCellClick?.({ mese: m, ramo: r, ...c })}
                      className={`w-full h-7 rounded text-[11px] font-medium ${cls} ${c.count > 0 ? "hover:ring-2 hover:ring-emerald-600 cursor-pointer" : "cursor-default"}`}
                      title={`${RAMI_LABEL[r] || r} · ${fmtMese(m)} → ${c.count} polizze · €${Math.round(c.importo).toLocaleString("it-IT")}`}
                      disabled={c.count === 0}
                      data-testid={`cm-heatmap-cell-${m}-${r}`}>
                      {c.count > 0 ? c.count : ""}
                    </button>
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
      <div className="flex items-center gap-2 mt-3 text-[10px] text-zinc-500">
        <span>Meno</span>
        <span className="w-4 h-3 rounded bg-emerald-100"></span>
        <span className="w-4 h-3 rounded bg-emerald-300"></span>
        <span className="w-4 h-3 rounded bg-emerald-500"></span>
        <span className="w-4 h-3 rounded bg-emerald-700"></span>
        <span>Più scadenze</span>
      </div>
    </div>
  );
}
